import React from 'react';
import { Subtitle } from './RegistrationCard.styles';

interface CompletedOnProps {
  endDate: string | undefined;
}

export const CompletedOnSubTitle = ({ endDate }: CompletedOnProps) => (
  <Subtitle>
    Registration Completed On:&nbsp;
    <span>
      {endDate &&
        new Date(endDate).toLocaleString('default', {
          month: 'short',
          day: 'numeric',
          year: 'numeric',
        })}
    </span>
  </Subtitle>
);
